import { v4 as uuid } from 'uuid';
import { ViewReport } from 'modules/analytics/models';
import { StateViewModel } from './detail/portal-submodule-builder/templates/builder/models/viewModels/StateViewModel';
import { ConfigurationFeatures } from './detail/configurations/ConfigurationFeatures';
export class MarketplaceTemplatesService {
    static $inject = ['MessagingHubService', 'BuilderService', 'HostingService', 'AccountService2', 'TeamService', 'TenantService', 'AnalyticsReportsService', '$base64', 'AnalyticsChartsService'];
    constructor(MessagingHubService, BuilderService, HostingService, AccountService2, TeamService, TenantService, AnalyticsReportsService, $base64, AnalyticsChartsService) {
        'ngInject';
        this.MessagingHubService = MessagingHubService;
        this.BuilderService = BuilderService;
        this.HostingService = HostingService;
        this.AccountService2 = AccountService2;
        this.TeamService = TeamService;
        this.TenantService = TenantService;
        this.AnalyticsReportsService = AnalyticsReportsService;
        this.$base64 = $base64;
        this.AnalyticsChartsService = AnalyticsChartsService;
        this.isConfigurationsApplicationSetEnabled = false;
        this.AccountService2.me().then((me) => {
            this.me = me;
        });
        this.checkFeatures();
    }
    /**
     * Process template steps
     * @param application
     */
    async processTemplate(application) {
        const errors = [];
        application.applicationJson = await this.HostingService.getApplicationJson(application);
        if (!this.isSanitizeAccessKeyInBot) {
            application.applicationJson.accessKey = application.accessKey;
        }
        else {
            delete application.applicationJson.accessKey;
        }
        application.isTemplate = true;
        for (let i = 0; i < application.marketplace.template.steps.length; i++) {
            try {
                await this.runStep(application.marketplace.template.steps[i], application);
            }
            catch (e) {
                errors.push(e);
            }
        }
        return errors.length;
    }
    async checkFeatures() {
        this.isBillableContract = await this.TenantService.checkIfBillableContract();
        this.isSanitizeAccessKeyInBot = await ConfigurationFeatures.isSanitizeAccessKeyInBot();
        this.isConfigurationsApplicationSetEnabled = await ConfigurationFeatures.isConfigurationDomainOnAdvancedConfigurationPropertiesSetEnabled();
    }
    async runStep(step, application) {
        switch (step.type) {
            case 'SendCommand':
                break;
            case 'PublishFlow':
                const originalKey = this.$base64.decode(application.accessKey);
                const userAndKey = `${application.shortName}:${originalKey}`;
                let flowId;
                if (application.applicationJson.settings) {
                    flowId = application.applicationJson.settings.flow.id;
                }
                else {
                    flowId = uuid();
                }
                step.arguments.settings.token = this.$base64.encode(userAndKey);
                await this.BuilderService.publishFlow(step.arguments.flow, step.arguments.settings, new StateViewModel(), application, flowId);
                break;
            case 'PublishHelpdesks':
                for (let i = 0; i < step.arguments.length; i++) {
                    const helpdeskChannel = step.arguments[i];
                    const publishHelpdesksCommand = {
                        method: 'set',
                        uri: 'lime://postmaster@desk.msging.net/configuration',
                        type: 'application/json',
                        resource: {
                            'Lime.IsActive': true,
                            'DefaultProvider': helpdeskChannel,
                        },
                        to: this.isConfigurationsApplicationSetEnabled ? 'postmaster@configurations.msging.net' : undefined,
                    };
                    await this.MessagingHubService.sendCommand(publishHelpdesksCommand);
                }
                break;
            case 'AddAgent':
                if (this.isBillableContract) {
                    break;
                }
                const agents = step.arguments.map((agentIdentity) => {
                    const identity = agentIdentity === 'owner' ? this.me.email : agentIdentity;
                    return {
                        teams: ['Default'],
                        identity: `${encodeURIComponent(identity)}@blip.ai`,
                        isEnabled: true,
                    };
                });
                await this.TeamService.set(agents);
                break;
            case 'AddReport':
                for (let i = 0; i < step.arguments.length; i++) {
                    const reportArg = step.arguments[i];
                    const viewReport = new ViewReport({
                        isPrivate: false,
                        owner: this.me,
                        name: reportArg.name,
                        ownerUserIdentity: `${encodeURIComponent(this.me.email)}@blip.ai`,
                    });
                    viewReport.id = await this.AnalyticsReportsService.set(viewReport);
                    await this.AnalyticsChartsService.setMany(viewReport.id, reportArg.charts);
                }
                break;
        }
    }
}
// Explicit AngularJS DI annotation for minification safety
// Order must match constructor parameter order
MarketplaceTemplatesService.$inject = ['MessagingHubService', 'BuilderService', 'HostingService', 'AccountService2', 'TeamService', 'TenantService', 'AnalyticsReportsService', '$base64', 'AnalyticsChartsService'];
